import React, { Component } from 'react';
import styles from "../index.css";
import {observer} from 'mobx-react';
import TabListElement from "../TabListElement";
import {dcUnitsStore, scenario, shipment, storageStore} from "../../../stores";
import {Bunker, DryingCleaningUnit, Hopper, Silo} from "../../Game/SubComponents";

@observer
export default class PathPopupTabs extends Component{
    state={
        tab:0
    };

    setTab(id){
        this.setState({tab:id})
    }

    itemList=[
        {name:"Хоппера",data:storageStore.hoppersList,endItem:false,unit:Hopper},
        {name:"Сушка",data:dcUnitsStore.dryingList,endItem:false,unit:DryingCleaningUnit},
        {name:"Чистка",data:dcUnitsStore.cleaningList,endItem:false,unit: DryingCleaningUnit},
        {name:"Хранение",data:storageStore.silosList,endItem:true,unit:Silo},
        {name:"Отгрузка",data:shipment.shipmentBunker,endItem:true,unit:Bunker}
    ];

    render(){
        return(
            <div>
                <div className={styles.tabs}>
                    {this.itemList.map((item,i)=>(
                        <div className={this.state.tab === i ? styles.activeTab : ""} onClick={this.setTab.bind(this,i)} key={i}>{item.name}</div>
                    ))}
                </div>
                <div className={styles.dragContainer}>
                    {this.itemList[this.state.tab].data.filter((item)=>(!scenario.script.find((elem)=>(elem.num===item.num && elem.type === item.type)))).map((item,i)=>{
                        return(
                            <TabListElement
                                setDrop={this.props.setDrop.bind(this,item)}
                                DomElement={this.itemList[this.state.tab].unit} item={item} id={i}
                                hoverElementCheck={{tabs:this.props.hoveredDom,id:this.props.hoverId}}
                                onMouseOver={this.props.setHoverElement.bind(this,item,i,'tabs')} key={i}/>
                        )
                    })}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/PathPopupTabs/index.js